import { Stack, Typography } from '@mui/material';

import { QUESTIONS } from '@/benefits-flow/screener/questions';
import QuestionField from '@/benefits-flow/screener/QuestionField';
import Screen from '@/karehero-app/explore/Screen';
import {
  PERSON,
  TAP,
} from '@/karehero-app/explore/benefits-calculator/BenefitsCalculator.content';
import {
  Note,
  Results,
} from '@/karehero-app/explore/benefits-calculator/Parts';

// Section B. What answering the calculator looks like today: one question a
// screen, tap an option, next. The control the other modes are measured against,
// and worth showing at full fidelity — it is genuinely good, and the argument is
// about what to add to it rather than what to replace.
//
// The question renderer is the real one from the benefits-flow prototype, not a
// redraw, so these frames show the actual bands the engine reads.

const noop = () => undefined;

const Asked = ({
  id,
  step,
  value,
}: {
  id: string;
  step: number;
  value?: boolean | string;
}) => (
  <Screen back>
    <Stack spacing={2}>
      <Typography variant='caption' color='text.secondary'>
        {TAP.progress(step, 8)}
      </Typography>
      <QuestionField
        question={QUESTIONS[id]}
        recipientName={PERSON.name}
        value={value}
        onChange={noop}
      />
    </Stack>
  </Screen>
);

export const B1Asked = () => (
  <Asked id='care-recipient-needs-help-time-of-day' step={3} />
);
B1Asked.displayName = 'B1Asked';

export const B2Tapped = () => (
  <Asked
    id='care-recipient-needs-help-time-of-day'
    step={3}
    value='care-recipient-needs-help-during-both'
  />
);
B2Tapped.displayName = 'B2Tapped';

// Early stopping, made visible. Today the questions simply are not there; the
// frame argues they should be seen going, because a question set that shrinks
// is the strongest thing this flow has to say for itself.
export const B3Pruned = () => (
  <Screen title={TAP.pruned.title}>
    <Stack spacing={2}>
      <Typography variant='body2' color='text.secondary'>
        {TAP.pruned.body}
      </Typography>
      <Note
        title='Skipped'
        icon='check'
        body='Universal Credit, the work-capability question, and the under-66 disability route.'
      />
    </Stack>
  </Screen>
);
B3Pruned.displayName = 'B3Pruned';

export const B4Results = () => (
  <Screen>
    <Results
      input={{
        nation: 'england',
        ageYears: 84,
        needsHelp: 'both',
        isDisabled: true,
        conditionDuration: '6-months',
        disabilityTypes: ['other'],
        savings: 10000,
        weeklyIncome: 200,
        hasPartner: false,
      }}
    />
  </Screen>
);
B4Results.displayName = 'B4Results';
